import styled from 'styled-components'

export const MapContainer = styled.div`
  height:400px;
  width:100%;
`
